export const CUSTOMIZATION_TYPES = {
  SINGLE_SELECT: 0,
  QUANTITY: 1,
  MULTI_SELECT: 2,
  MULTI_SELECT_QUANTITY: 3,
  MULTI_SELECT_FIXED: 4,
  VARIANT: 5,
  AUTOMATIC_VARIANT: 6,
  DISCOUNT: 69
};
